<template>
    <div class="snt w-full max-lg:mt-[500px] -mt-28 max-md:px-2">
        <div class="snt-inner -observed">
            <div class="snt-bg">
                <div class="snt-bg-part max-lg:left-1/2 max-lg:-translate-x-1/2 lg:left-0 min-w-max">
                    <span v-for="i in 11" :key="`left-ph-${i}`" class="snt-bg-ph"></span>
                    <div v-for="(img, index) in leftImages" :key="`left-${index}-${imageUpdateCounter}`"
                        class="snt-bg-item">
                        <div class="snt-bg-item-cr"></div>
                        <div class="snt-bg-item-cr"></div>
                        <div class="snt-bg-item-cr"></div>
                        <div class="snt-bg-item-cr"></div>
                        <transition name="fade">
                            <NuxtImg alt="techImg" v-if="img" class="snt-bg-item-image" :src="img" :width="isMobile ? 28 : 32" :height="isMobile ? 28 : 32" loading="lazy"  format="webp" />
                        </transition>
                    </div>
                </div>
                <div v-if="isDesktop" class="snt-bg-part right-0 max-lg:hidden">
                    <span v-for="i in 11" :key="`right-ph-${i}`" class="snt-bg-ph"></span>
                    <div v-for="(img, index) in rightImages" :key="`right-${index}-${imageUpdateCounter}`"
                        class="snt-bg-item">
                        <div class="snt-bg-item-cr"></div>
                        <div class="snt-bg-item-cr"></div>
                        <div class="snt-bg-item-cr"></div>
                        <div class="snt-bg-item-cr"></div>
                        <transition name="fade">
                            <NuxtImg alt="techImg" v-if="img" class="snt-bg-item-image" :src="img" :width="isMobile ? 28 : 32" :height="isMobile ? 28 : 32" loading="lazy"  format="webp" />
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const {isMobile} = useDevice()
import { ref, onMounted, onBeforeUnmount } from 'vue';

const {isDesktop} = useDevice();
const props = defineProps({
    interval: {
        type: Number,
        default: 3000
    }
});

const initialLeftFrameworkImg = [
    '/images/laravel.webp',
    '',
    '/images/fastify.webp',
    '',
    '',
    '/images/swift.webp',
    '',
    '/images/express.webp',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
];

const initialRightFrameworkImg = [
    '/images/mysql.webp',
    '',
    '/images/vercel.webp',
    '',
    '',
    '/images/fauna.webp',
    '',
    '/images/ionic.webp',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',

];

const alternateLeftFrameworkImg = [
    '',
    '/images/mysql.webp',
    '',
    '/images/vercel.webp',
    '',
    '',
    '/images/fauna.webp',
    '',
    '/images/ionic.webp',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
];

const alternateRightFrameworkImg = [
    '',
    '',
    '/images/mysql.webp',
    '',
    '',
    '',
    '/images/vercel.webp',
    '',
    '',
    '',
    '/images/fauna.webp',
    '',
    '',
    '',
    '',
    '/images/ionic.webp',
    '',
];

const leftImages = ref([...initialLeftFrameworkImg]);
const rightImages = ref([...initialRightFrameworkImg]);
const imageUpdateCounter = ref(0);

let transitionTimer = null;

const toggleImages = () => {
    imageUpdateCounter.value++;

    setTimeout(() => {
        if (leftImages.value[0] === initialLeftFrameworkImg[0]) {
            leftImages.value = [...alternateLeftFrameworkImg];
            rightImages.value = [...alternateRightFrameworkImg];
        } else {
            leftImages.value = [...initialLeftFrameworkImg];
            rightImages.value = [...initialRightFrameworkImg];
        }
    }, 600); 
};

onMounted(() => {
    if (process.client) {
        transitionTimer = setInterval(toggleImages, props.interval);
    }
});

onBeforeUnmount(() => {
    if (transitionTimer) {
        clearInterval(transitionTimer);
        transitionTimer = null;
    }
});
</script>

<style scoped>

</style>